// 预定义的一组和谐颜色
const SUBJECT_COLORS = [
  '#4f46e5', // indigo
  '#ea580c', // orange
  '#0d9488', // teal
  '#b91c1c', // red
  '#4338ca', // indigo dark
  '#15803d', // green
  '#7c2d12', // orange dark
  '#6d28d9', // purple
  '#1e40af', // blue dark
  '#be123c', // rose
  '#374151', // gray dark
];

// Program type specific colors with better visual hierarchy
const PROGRAM_TYPE_COLORS = {
  major: {
    bg: 'bg-fuchsia-50',
    text: 'text-fuchsia-700',
    border: 'border-fuchsia-200',
  },
  minor: {
    bg: 'bg-amber-50', 
    text: 'text-amber-700',
    border: 'border-amber-200',
  },
  college: {
    bg: 'bg-purple-50',
    text: 'text-purple-700',
    border: 'border-purple-200',
  }
} as const;

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

export function generateColorMap<T>(courses: T[], getKey: (course: T) => string): Record<string, string> {
  const colorMap: Record<string, string> = {};
  const usedIndices = new Set<number>();
  const numColors = SUBJECT_COLORS.length;

  const entries: { key: string; preferredIndex: number }[] = [];
  const seen = new Set<string>();
  for (const course of courses) {
    const key = getKey(course);
    if (seen.has(key)) continue;
    seen.add(key);
    entries.push({ key, preferredIndex: hashString(key) % numColors });
  }

  // Sort by preferred index for deterministic collision resolution
  entries.sort((a, b) => a.preferredIndex - b.preferredIndex || a.key.localeCompare(b.key));

  for (const { key, preferredIndex } of entries) {
    if (usedIndices.size >= numColors) {
      colorMap[key] = SUBJECT_COLORS[preferredIndex];
      continue;
    }

    let index = preferredIndex;
    while (usedIndices.has(index)) {
      index = (index + 1) % numColors;
    }

    colorMap[key] = SUBJECT_COLORS[index];
    usedIndices.add(index);
  }

  return colorMap;
}